module.exports = __webpack_public_path__ + "media/images/basic_logos/snack-1fb5cc20b768e637f9966eead42b9f2d.svg";